import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';

const DISMISS_KEY = 'cookie-notice-dismissed';

/**
 * Lightweight, informational cookie notice. The Service uses only essential +
 * functional storage and no trackers, so this does NOT gate the site or block
 * anything — it just informs and links to the Cookie Policy. Dismissal is
 * remembered in localStorage so it appears at most once per browser.
 */
export function CookieNotice(): JSX.Element | null {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    try {
      setDismissed(localStorage.getItem(DISMISS_KEY) === '1');
    } catch {
      // Private mode / storage blocked — show once, don't crash.
      setDismissed(false);
    }
  }, []);

  if (dismissed) return null;

  const dismiss = (): void => {
    try {
      localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // ignore
    }
    setDismissed(true);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t bg-background/95 backdrop-blur">
      <div className="container flex flex-col items-start gap-3 py-3 text-sm sm:flex-row sm:items-center sm:justify-between">
        <p className="text-muted-foreground">
          We use only essential cookies to run the site — no tracking.{' '}
          <Link to="/cookies" className="text-foreground underline underline-offset-4">
            Read our cookie policy
          </Link>
          .
        </p>
        <Button size="sm" onClick={dismiss} className="flex-shrink-0">
          Got it
        </Button>
      </div>
    </div>
  );
}
